// DEV-1003: the tabs of the paged Data Requests list. Values match the backend DataRequestListTab enum.
export enum DataRequestListTabEnum {
    AwaitingMyAction = 'AwaitingMyAction',
    Draft = 'Draft',
    Active = 'Active',
    NotApproved = 'NotApproved',
    Withdrawn = 'Withdrawn',
    Archived = 'Archived'
}

// DEV-1003: the only fields a Data Requests page may be sorted by. Values match the backend
// DataRequestSummarySortField enum. DataRequestDoi is the stored field behind idString.
export enum DataRequestSummarySortFieldEnum {
    DataRequestDoi = 'DataRequestDoi',
    CreatedTime = 'CreatedTime',
    UpdatedDate = 'UpdatedDate'
}
